/**
 * Redux slice for call documenter dialog state
 *
 * This slice manages the open/close state of the call documentation dialog.
 */

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CallDocumenterState {
  isOpen: boolean;
  callId: number | null;
  leadId: number | null;
}

const initialState: CallDocumenterState = {
  isOpen: false,
  callId: null,
  leadId: null,
};

const callDocumenterSlice = createSlice({
  name: "callDocumenter",
  initialState,
  reducers: {
    openDialog: (
      state,
      action: PayloadAction<{ callId: number; leadId: number }>
    ) => {
      state.isOpen = true;
      state.callId = action.payload.callId;
      state.leadId = action.payload.leadId;
    },
    closeDialog: (state) => {
      state.isOpen = false;
      state.callId = null;
      state.leadId = null;
    },
  },
});

export const { openDialog, closeDialog } = callDocumenterSlice.actions;

export default callDocumenterSlice.reducer;
